module.exports = __webpack_public_path__ + "img/logo.cdb01798.svg";